import { Component, ViewChild } from '@angular/core';
import { VerTareasComponent } from '../../../forms/tareas/ver-tareas/ver-tareas.component';

@Component({
  selector: 'app-tareas',
  templateUrl: './tareas.component.html',
  styleUrls: ['./tareas.component.scss']
})
export class TareasComponent {
  @ViewChild('verTareas') verTareas: VerTareasComponent;

  constructor() { }

  actualizarTabla(): void {
    this.verTareas.actualizarTabla();
  }
}
